import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// PUBLIC "Hemen Basla": web sitesinden (biyapayzeka.com / british.com.tr) gelen ziyaretci
// GIRIS YAPMADAN dogrudan ilgili urunun AYLIK aboneligini baslatir.
// Klasik SaaS akisi: kayit -> giris (token) -> recurring/start (trialDays:0 = denemesiz, direkt aylik).
const PLAIN = { "Content-Type": "application/json" };

const ICONS = { english: "🇬🇧", kids: "🧒", german: "🇩🇪", spanish: "🇪🇸", french: "🇫🇷", ielts: "📘", toefl: "📕", yds: "🎯", yokdil: "🎯", yökdil: "🎯", kpss: "🎓", russian: "🇷🇺", arabic: "🇸🇦", arabİc: "🇸🇦", turkish: "🇹🇷", pte: "📗", lgs: "🏫", tyt: "🎓", ayt: "🎓", astrolog: "🔮" };
function iconFor(name) { const n = (name || "").toLowerCase(); for (const k in ICONS) if (n.includes(k)) return ICONS[k]; return "🎓"; }
function cleanName(name) { return (name || "").replace(/\s*Basic Paket\s*/i, "").replace(/\s*Paket\s*/i, "").trim() || name; }
// TR karakter + bosluk + tire normalize (bot kodu eslesmesi icin)
function norm(s) { return (s || "").toString().toLowerCase().replace(/İ/g, "i").replace(/I/g, "i").replace(/ı/g, "i").replace(/[\s-]/g, ""); }

// --- Kart alani yardimcilari (format + dogrulama) ---
const onlyDigits = (v) => (v || "").replace(/\D/g, "");
// 16-19 haneyi 4'erli gruplar halinde bosluklu goster: "1234 5678 9012 3456"
function fmtCardNumber(v) { return onlyDigits(v).slice(0, 19).replace(/(.{4})/g, "$1 ").trim(); }
// AA/YY: 3. haneden itibaren otomatik "/" ekler
function fmtExp(v) { const d = onlyDigits(v).slice(0, 4); return d.length >= 3 ? d.slice(0, 2) + "/" + d.slice(2) : d; }
function fmtCvv(v) { return onlyDigits(v).slice(0, 4); }
// Luhn (mod-10) kart numarasi kontrolu — yanlis yazilan numarayi bankaya gitmeden yakalar
function luhnValid(num) {
  const s = onlyDigits(num);
  if (s.length < 13 || s.length > 19) return false;
  let sum = 0, alt = false;
  for (let i = s.length - 1; i >= 0; i--) {
    let n = parseInt(s[i], 10);
    if (alt) { n *= 2; if (n > 9) n -= 9; }
    sum += n; alt = !alt;
  }
  return sum % 10 === 0;
}

export default function HemenBasla() {
  const navigate = useNavigate();
  const params = useParams();
  const botCode = decodeURIComponent(params.bot || "").trim();
  // URL'de ?kupon=KOD (or ?k=KOD) varsa otomatik uygulanir ( or. landing linkleri)
  const urlKupon = (() => { try { const q = new URLSearchParams(window.location.search); return (q.get("kupon") || q.get("k") || "").trim(); } catch { return ""; } })();

  const [sel, setSel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ ad: "", email: "", tel: "", sifre: "" });
  const [card, setCard] = useState({ owner: "", number: "", exp: "", cvv: "" });
  const [cardErrs, setCardErrs] = useState({}); // alan-bazli kart hatalari
  const [consent, setConsent] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [kupon, setKupon] = useState(urlKupon);
  const [kuponMsg, setKuponMsg] = useState("");
  const [disc, setDisc] = useState(null); // { price, rate } indirim uygulandiysa
  const [kbusy, setKbusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/api/packages", { headers: PLAIN }); // PUBLIC
        const d = await r.json();
        const list = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
        const basics = list.filter(p => p.isActive !== false && Number(p.price) > 0 && /basic/i.test(p.name || ""));
        // ISIM-ONCELIKLI: paket adi bot koduyla baslamali (benzersiz). Sonra bots[] fallback.
        // (bots[] once denenirse, cok-botlu paketler yanlis eslesir: biENGLISH -> biKIDS gibi.)
        let pkg = basics.find(p => norm(p.name).indexOf(norm(botCode)) === 0);
        if (!pkg) pkg = basics.find(p => (p.bots || []).some(b => (b.name || "") === botCode));
        if (!pkg) pkg = basics.find(p => (p.bots || []).some(b => norm(b.name) === norm(botCode)));
        if (pkg) setSel(pkg); else setErr("Bu egitim icin abonelik paketi bulunamadi.");
      } catch { setErr("Paket yuklenemedi, lutfen tekrar dene."); }
      finally { setLoading(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botCode]);

  const fmt = (n) => (Number(n) || 0).toLocaleString("tr-TR");
  const effPrice = disc ? disc.price : (sel ? sel.price : 0);

  const applyCoupon = async () => {
    setKuponMsg("");
    if (!sel) return;
    if (!kupon.trim()) { setKuponMsg("Lütfen bir kupon kodu gir."); return; }
    setKbusy(true);
    try {
      const r = await jpost("/api/payments/esnekpos/campaign/validate-public", { code: kupon.trim(), packageId: sel._id });
      if (r.ok && r.d?.ok) { setDisc({ price: r.d.discountedPrice, rate: r.d.discountRate }); setKuponMsg("✓ İndirim uygulandı"); }
      else { setDisc(null); setKuponMsg("Geçersiz veya süresi geçmiş kupon."); }
    } catch { setDisc(null); setKuponMsg("Kupon kontrol edilemedi."); }
    finally { setKbusy(false); }
  };

  // URL'de ?kupon=KOD varsa: paket yuklenince (sel hazir) indirimi OTOMATIK dogrula+uygula
  useEffect(() => {
    if (!sel || !urlKupon || disc) return;
    (async () => {
      setKbusy(true);
      try {
        const r = await jpost("/api/payments/esnekpos/campaign/validate-public", { code: urlKupon, packageId: sel._id });
        if (r.ok && r.d?.ok) { setKupon(urlKupon); setDisc({ price: r.d.discountedPrice, rate: r.d.discountRate }); setKuponMsg("✓ İndirim uygulandı"); }
      } catch { /* sessiz: kullanici elle de deneyebilir */ }
      finally { setKbusy(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sel]);

  async function jpost(url, body, token) {
    const headers = token ? { ...PLAIN, Authorization: "Bearer " + token } : PLAIN;
    const r = await fetch(url, { method: "POST", headers, body: JSON.stringify(body) });
    let d = {}; try { d = await r.json(); } catch {}
    return { ok: r.ok, status: r.status, d };
  }

  // Kart alanlarini tek tek dogrular; her hatali alan icin mesaj dondurur.
  function validateCardFields() {
    const e = {};
    const digits = onlyDigits(card.number);
    const ex = onlyDigits(card.exp); const mm = ex.slice(0, 2); const yy = ex.slice(2);
    if (!card.owner.trim()) e.owner = "Kart üzerindeki ismi gir.";
    if (digits.length < 15) e.number = "Kart numarasını eksiksiz gir.";
    else if (!luhnValid(digits)) e.number = "Kart numarası hatalı görünüyor.";
    const mmN = parseInt(mm || "0", 10);
    if (ex.length < 4) e.exp = "Son kullanma tarihini gir (AA/YY).";
    else if (mmN < 1 || mmN > 12) e.exp = "Ay 01–12 arası olmalı.";
    else { const expEnd = new Date(2000 + parseInt(yy, 10), mmN, 0, 23, 59, 59); if (expEnd < new Date()) e.exp = "Kartın son kullanma tarihi geçmiş."; }
    if (card.cvv.length < 3) e.cvv = "CVV 3–4 haneli olmalı.";
    return e;
  }

  const start = async () => {
    if (!sel) return;
    setErr("");
    const parts = form.ad.trim().split(/\s+/);
    const name = parts[0] || ""; const surname = parts.slice(1).join(" ");
    if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email.trim()) || form.tel.replace(/\D/g, "").length < 10 || form.sifre.length < 6) {
      setErr("Lutfen ad, gecerli e-posta, telefon ve en az 6 haneli sifre gir."); return;
    }
    const digits = card.number.replace(/\D/g, "");
    const ex = card.exp.replace(/\D/g, ""); const mm = ex.slice(0, 2); const yy = ex.slice(2);
    const cErr = validateCardFields();
    setCardErrs(cErr);
    if (Object.keys(cErr).length) { setErr("Kart bilgilerini kontrol et."); return; }
    if (!consent) { setErr("Devam etmek icin onay kutusunu isaretle."); return; }

    setBusy(true);
    try {
      const email = form.email.trim().toLowerCase();
      // KAYIT (zaten varsa backend hata verir, login denenir)
      const reg = await jpost("/api/platform/auth/register", { name, surname, email, password: form.sifre, phone: form.tel.trim() });
      // GIRIS -> token
      const log = await jpost("/api/platform/auth/login", { emailOrUsername: email, password: form.sifre });
      const tokenV = log.d.token || log.d.accessToken || (log.d.data && log.d.data.token) || "";
      if (!tokenV) {
        setErr(reg.ok ? "Giris yapilamadi, tekrar dene." : (reg.d.message || "Bu e-posta zaten kayitli olabilir; sifreni kontrol et."));
        setBusy(false); return;
      }
      try { localStorage.setItem("biyz_token", tokenV); if (log.d.user) localStorage.setItem("biyz_user", JSON.stringify(log.d.user)); } catch {}
      // ABONELIK BASLAT — DENEMESIZ (trialDays:0), direkt aylik, kampanya yok (tam fiyat)
      const sub = await jpost("/api/payments/esnekpos/recurring/start", {
        packageId: sel._id, trialDays: 0,
        campaignCode: kupon.trim() || undefined,
        card: { CC_OWNER: card.owner.trim(), CC_NUMBER: digits, EXP_MONTH: mm, EXP_YEAR: yy.length === 2 ? ("20" + yy) : yy, CC_CVV: card.cvv },
      }, tokenV);
      if (!sub.ok || !sub.d.ok) { setErr(sub.d.error === "recurring_init_failed" ? (sub.d.detail?.message || "Odeme reddedildi, kartini kontrol et") : (sub.d.error || "Abonelik baslatilamadi")); setBusy(false); return; }
      setDone(true); window.scrollTo(0, 0);
    } catch { setErr("Sunucuya baglanilamadi"); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#eef2f7" }}>
      <style>{CSS}</style>

      <header className="df-header">
        <div className="df-wrap">
          <div className="df-brand"><span className="df-lbadge">bi</span><span className="df-word"><span className="df-w1">bi</span><span className="df-w2">YAPAYZEKA</span></span></div>
          <div className="df-chip">🎁 Davetle geldin — sana özel</div>
          <div className="df-hello">Sana Özel Bir Fırsatımız Var 🎁
            <small><b>7 gün ücretsiz dene</b> — beğenirsen sana özel <b>%30 indirimle</b> devam et</small>
          </div>
        </div>
      </header>

      <div className="df-wrap">
        {loading && <div className="df-loading" style={{ marginTop: 40 }}>Yükleniyor…</div>}
        {!loading && !sel && <div className="df-err" style={{ marginTop: 40 }}>{err || "Paket bulunamadı."}</div>}

        {!done && sel && (
          <>
            <div className="df-offer">
              Seçtiğin eğitimde <b>7 GÜN ÜCRETSİZ</b> 🎁 &nbsp;Beğenirsen sana özel <b>%30 indirimle</b> devam et — <b>istediğin an tek tıkla iptal.</b>
            </div>
          <div className="df-panel">
            <div className="df-sel-head">
              <div className="df-ico">{iconFor(sel.name)}</div>
              <div><h2>{cleanName(sel.name)} — Elit Üyelik</h2><div className="df-muted">Aylık abonelik · istediğin an iptal</div></div>
            </div>
            <div className="df-pricebox">
              <div className="df-row">
                <span className="df-big">Aylık üyelik</span>
                <span className="df-big">{disc ? (<><span className="df-oldp">{fmt(sel.price)} ₺</span> {fmt(effPrice)} ₺/ay</>) : (<>{fmt(sel.price)} ₺/ay</>)}</span>
              </div>
              {disc && <div className="df-row"><span className="df-freen">Kupon indirimi{disc.rate ? " (%" + disc.rate + ")" : ""}</span><span className="df-freen">uygulandı ✓</span></div>}
              <div className="df-row"><span>İlk çekim</span><span className="df-free">bugün</span></div>
              <div className="df-coupon">
                <input value={kupon} onChange={e => { setKupon(e.target.value); setDisc(null); setKuponMsg(""); }} placeholder="İndirim kuponu (opsiyonel)" />
                <button type="button" className="df-capply" disabled={kbusy} onClick={applyCoupon}>{kbusy ? "…" : "Uygula"}</button>
              </div>
              {kuponMsg && <div className={disc ? "df-cok" : "df-cbad"}>{kuponMsg}</div>}
            </div>

            <div className="df-ftitle">Hesap Bilgilerin</div>
            <div className="df-form">
              <div className="df-full"><label>Ad Soyad</label><input value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} placeholder="Ad Soyad" /></div>
              <div className="df-full"><label>E-posta</label><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="ornek@eposta.com" inputMode="email" /></div>
              <div><label>Telefon</label><input value={form.tel} onChange={e => setForm({ ...form, tel: e.target.value })} placeholder="05xx xxx xx xx" inputMode="numeric" /></div>
              <div><label>Şifre (min 6)</label><input type="password" value={form.sifre} onChange={e => setForm({ ...form, sifre: e.target.value })} placeholder="••••••" /></div>
            </div>

            <div className="df-ftitle">Kart Bilgilerin</div>
            <div className="df-disclose">
              <b>Net bilgilendirme:</b> Aboneliğin bugün başlar ve kartından <b>aylık {fmt(effPrice)} ₺</b> çekilir; her ay otomatik yenilenir.
              Aboneliğini panelinden <b>tek tıkla, istediğin an</b> iptal edebilirsin.
            </div>
            {err && <div className="df-err">{err}</div>}
            <div className="df-form">
              <div className="df-full"><label>Kart Üzerindeki İsim</label>
                <input value={card.owner} autoComplete="cc-name"
                  onChange={e => { setCard({ ...card, owner: e.target.value }); if (cardErrs.owner) setCardErrs({ ...cardErrs, owner: undefined }); }}
                  placeholder="Ad Soyad" />
                {cardErrs.owner && <div className="df-fielderr">{cardErrs.owner}</div>}
              </div>
              <div className="df-full"><label>Kart Numarası</label>
                <input value={card.number} autoComplete="cc-number" inputMode="numeric" maxLength={23}
                  onChange={e => { setCard({ ...card, number: fmtCardNumber(e.target.value) }); if (cardErrs.number) setCardErrs({ ...cardErrs, number: undefined }); }}
                  placeholder="0000 0000 0000 0000" />
                {cardErrs.number && <div className="df-fielderr">{cardErrs.number}</div>}
              </div>
              <div><label>Son Kullanma (AA/YY)</label>
                <input value={card.exp} autoComplete="cc-exp" inputMode="numeric" maxLength={5}
                  onChange={e => { setCard({ ...card, exp: fmtExp(e.target.value) }); if (cardErrs.exp) setCardErrs({ ...cardErrs, exp: undefined }); }}
                  placeholder="AA/YY" />
                {cardErrs.exp && <div className="df-fielderr">{cardErrs.exp}</div>}
              </div>
              <div><label>CVV</label>
                <input value={card.cvv} autoComplete="cc-csc" inputMode="numeric" maxLength={4}
                  onChange={e => { setCard({ ...card, cvv: fmtCvv(e.target.value) }); if (cardErrs.cvv) setCardErrs({ ...cardErrs, cvv: undefined }); }}
                  placeholder="123" />
                {cardErrs.cvv && <div className="df-fielderr">{cardErrs.cvv}</div>}
              </div>
            </div>
            <label className="df-accept"><input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} /><span>Aylık <b>{fmt(effPrice)} ₺/ay</b> otomatik yenilenen abonelik koşullarını okudum, onaylıyorum.</span></label>
            <button className="df-start" disabled={busy} onClick={start}>{busy ? "İşleniyor…" : "Elit Üyeliğimi Başlat →"}</button>
            <div className="df-cancel-note">🔒 Güvenli ödeme · Aylık abonelik · Tek tıkla iptal</div>
          </div>
          </>
        )}

        {done && sel && (
          <div className="df-ok">
            <div className="df-ok-big">🎉</div>
            <h2>Hoş geldin!</h2>
            <p><b>{cleanName(sel.name)}</b> aylık aboneliğin başladı. Hesabın oluşturuldu ve giriş yapıldı.</p>
            <button className="df-start" style={{ maxWidth: 320, margin: "0 auto" }} onClick={() => navigate("/chat")}>Eğitime Başla →</button>
          </div>
        )}
      </div>
    </div>
  );
}

const CSS = `
.df-wrap{max-width:920px;margin:0 auto;padding:0 16px}
.df-header{background:linear-gradient(135deg,#0d2a52,#1565c0);color:#fff;padding:26px 0 74px;text-align:center;border-radius:0 0 28px 28px}
.df-brand{display:flex;align-items:center;gap:12px;justify-content:center;margin:0 auto 10px}
.df-lbadge{width:46px;height:46px;border-radius:13px;background:linear-gradient(135deg,#9E86FB,#7C5CFC);color:#fff;font-weight:800;font-size:22px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(124,92,252,.42)}
.df-word{font-weight:800;font-size:27px;letter-spacing:.3px}.df-w1{color:#fff}.df-w2{background:linear-gradient(90deg,#7C5CFC,#3B6BFF);-webkit-background-clip:text;background-clip:text;color:transparent}
.df-chip{display:inline-block;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.35);color:#fff;font-size:14.5px;font-weight:700;padding:8px 18px;border-radius:22px;margin-bottom:8px}
.df-hello{margin-top:6px;font-size:30px;font-weight:800}
.df-hello small{display:block;font-size:15px;font-weight:500;opacity:.92;margin-top:6px}
.df-loading{text-align:center;color:#6b7785;padding:30px}
.df-ico{font-size:30px}
.df-panel{background:#fff;border:1px solid #e3e9f0;border-radius:18px;padding:22px;margin:14px 0 40px;box-shadow:0 8px 30px rgba(13,42,82,.10)}
.df-offer{background:#fff;border:2px dashed #1565c0;border-radius:16px;margin:-46px auto 0;max-width:680px;padding:16px 18px;text-align:center;font-size:14px;color:#1a2233;box-shadow:0 8px 30px rgba(13,42,82,.12)}
.df-offer b{color:#1565c0}
.df-sel-head{display:flex;align-items:center;gap:12px;border-bottom:1px solid #e3e9f0;padding-bottom:14px;margin-bottom:14px}
.df-sel-head .df-ico{font-size:34px}
.df-sel-head h2{font-size:20px;color:#1a2233}
.df-muted{color:#6b7785;font-size:13px}
.df-blue{background:linear-gradient(135deg,#0d2a52,#1565c0);color:#fff;font-weight:800;font-size:13.5px;border-radius:12px;padding:12px 14px;margin-bottom:14px}
.df-pricebox{background:#f3f8ff;border:1px solid #cfe2fb;border-radius:14px;padding:16px;margin-bottom:16px}
.df-row{display:flex;justify-content:space-between;align-items:center;font-size:14px;padding:4px 0;color:#1a2233}
.df-big{font-size:17px;font-weight:800}
.df-free{color:#16a34a;font-weight:800}
.df-freen{color:#1565c0;font-weight:800;font-size:13px}
.df-oldp{text-decoration:line-through;color:#b4313b;font-size:13px;font-weight:700;margin-right:6px}
.df-coupon{display:flex;gap:8px;margin-top:12px}
.df-coupon input{flex:1;padding:10px;border:1px solid #cfe2fb;border-radius:10px;font-size:13.5px;background:#fff}
.df-capply{border:0;background:#1565c0;color:#fff;font-weight:700;padding:0 18px;border-radius:10px;cursor:pointer;font-size:13.5px}
.df-capply:hover{background:#0f4fa0}.df-capply:disabled{opacity:.6}
.df-cok{color:#16a34a;font-weight:700;font-size:12.5px;margin-top:7px}
.df-cbad{color:#b4313b;font-weight:700;font-size:12.5px;margin-top:7px}
.df-ftitle{font-weight:800;color:#0d2a52;font-size:15px;margin:6px 0 10px}
.df-disclose{font-size:12.5px;color:#5a6675;background:#fffaf0;border:1px solid #ffe7b3;border-radius:10px;padding:11px 13px;margin-bottom:14px}
.df-disclose b{color:#9a6a00}
.df-form{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:8px}
.df-form .df-full{grid-column:1/-1}
.df-form label{font-size:12.5px;color:#6b7785;display:block;margin-bottom:4px}
.df-form input{width:100%;padding:11px;border:1px solid #e3e9f0;border-radius:10px;font-size:14px;background:#fafcfe}
.df-accept{display:flex;gap:9px;align-items:flex-start;font-size:13px;margin:14px 0;color:#3a4757}
.df-accept input{width:auto;margin-top:3px}
.df-start{width:100%;border:0;background:linear-gradient(135deg,#1565c0,#1e88e5);color:#fff;font-weight:800;font-size:16px;padding:15px;border-radius:12px;cursor:pointer}
.df-start:hover{filter:brightness(1.05)}.df-start:disabled{opacity:.7;cursor:default}
.df-cancel-note{text-align:center;color:#6b7785;font-size:12px;margin-top:10px}
.df-err{background:#fdecef;border:1px solid #f5c2cd;color:#b4313b;border-radius:10px;padding:10px 13px;font-size:13px;margin:12px 0}
.df-fielderr{color:#b4313b;font-size:11.5px;font-weight:600;margin-top:4px}
.df-ok{text-align:center;padding:56px 0}
.df-ok-big{font-size:54px}.df-ok h2{font-size:24px;margin:10px 0;color:#1a2233}
.df-ok p{color:#6b7785;max-width:460px;margin:0 auto 18px}
@media(max-width:560px){.df-hello{font-size:24px}.df-form{grid-template-columns:1fr}}
`;
